import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './TouristInfo.css'; // Import your custom styles
import banner from '../../../Assets/Image/things-todo/yangudi.jpg'

const TouristInfo = () => {
  const touristInfo = {
    BahirDar: [
      { destination: 'Tisabay Tourist Information Center', contact: 'Tesfa Asmare', mobile: '+251937342603', phone: '+251582370054' },
      { destination: 'Bahirdar Airport Tourist Information Center', contact: 'Saleamlak Tilaye', mobile: '+251913449802', phone: '+251582370054' },
      { destination: 'Bahirdar Airport Tourist Information Center', contact: 'Wudeneh Betew', mobile: '+251911275111', phone: '' }
    ],
    Gondar: [
      { destination: 'Gonder Airport Tourist Information Center', contact: 'Aseged Tesfaye', mobile: '+251983154066', phone: '+251581110022' },
      { destination: 'Gonder Betemengist Tourist Information Center', contact: 'Serkie', mobile: '+251918030878', phone: '+251581110022' }
    ],
    Lalibela: [
      { destination: 'Lalibela Tourist Information Center', contact: 'Alemayehu Haile', mobile: '+251912345678', phone: '+251581123456' },
      { destination: 'Lalibela Airport Tourist Information Center', contact: 'Bekele Mesfin', mobile: '+251911234567', phone: '+251581123457' }
    ],
    Axum: [
      { destination: 'Axum Tourist Information Center', contact: 'Meron Gebremeskel', mobile: '+251914567890', phone: '+251582345678' },
      { destination: 'Axum Airport Tourist Information Center', contact: 'Genet Berhe', mobile: '+251913456789', phone: '+251582345679' }
    ],
    Harar: [
      { destination: 'Harar Tourist Information Center', contact: 'Hana Mohammed', mobile: '+251922334455', phone: '+251582223344' },
      { destination: 'Harar Airport Tourist Information Center', contact: 'Amin Tesfaye', mobile: '+251911223344', phone: '+251582223345' }
    ]
  };

  return (
    <div className="home-container">
      
      {/* Banner Section */}
      <div className="banner-container">
        <img
          src={banner} // Add your banner image here
          alt="Tourism Banner"
          className="banner-image"
        />
        <div className="banner-caption">
          <h1>Tourist Information Centers</h1>
          <p>Explore our centers and plan your visit with ease!</p>
        </div>
      </div>

      {/* Tables Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">Tourist Information Centers</h2>
        
        {/* Bahir Dar Table */}
        <div className="mb-5">
          <h3>Bahir Dar</h3>
          <table className="table table-striped table-bordered">
            <thead className="thead">
              <tr>
                <th>Destination</th>
                <th>Contact Person</th>
                <th>Mobile</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {touristInfo.BahirDar.map((item, index) => (
                <tr key={index}>
                  <td>{item.destination}</td>
                  <td>{item.contact}</td>
                  <td>{item.mobile}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Gondar Table */}
        <div className="mb-5">
          <h3>Gondar</h3>
          <table className="table table-striped table-bordered">
            <thead className="thead">
              <tr>
                <th>Destination</th>
                <th>Contact Person</th>
                <th>Mobile</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {touristInfo.Gondar.map((item, index) => (
                <tr key={index}>
                  <td>{item.destination}</td>
                  <td>{item.contact}</td>
                  <td>{item.mobile}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Lalibela Table */}
        <div className="mb-5">
          <h3>Lalibela</h3>
          <table className="table table-striped table-bordered">
            <thead className="thead">
              <tr>
                <th>Destination</th>
                <th>Contact Person</th>
                <th>Mobile</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {touristInfo.Lalibela.map((item, index) => (
                <tr key={index}>
                  <td>{item.destination}</td>
                  <td>{item.contact}</td>
                  <td>{item.mobile}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Axum Table */}
        <div className="mb-5">
          <h3>Axum</h3>
          <table className="table table-striped table-bordered">
            <thead className="thead">
              <tr>
                <th>Destination</th>
                <th>Contact Person</th>
                <th>Mobile</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {touristInfo.Axum.map((item, index) => (
                <tr key={index}>
                  <td>{item.destination}</td>
                  <td>{item.contact}</td>
                  <td>{item.mobile}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Harar Table */}
        <div className="mb-5">
          <h3>Harar</h3>
          <table className="table table-striped table-bordered">
            <thead className="thead">
              <tr>
                <th>Destination</th>
                <th>Contact Person</th>
                <th>Mobile</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {touristInfo.Harar.map((item, index) => (
                <tr key={index}>
                  <td>{item.destination}</td>
                  <td>{item.contact}</td>
                  <td>{item.mobile}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TouristInfo;
